import { Spherical, Vector3 } from 'three'
import { MapControls } from 'three/addons/controls/MapControls.js'

export default function setMapControlsAzimuthalAngle(
  controls: MapControls,
  azimuthalAngle: number
): void {
  const spherical = new Spherical()

  // Get current camera position relative to target in spherical coordinates
  const offset = new Vector3().subVectors(controls.object.position, controls.target)
  spherical.setFromVector3(offset)

  // Set the new azimuthal angle (no clamping usually necessary, but normalize for stability)
  spherical.theta = azimuthalAngle

  // Convert back to Cartesian coordinates
  offset.setFromSpherical(spherical)
  controls.object.position.copy(controls.target).add(offset)

  // Ensure the camera is still looking at the target
  controls.update()
}
